export default __webpack_public_path__ + "static/media/img-slider-craft-2024-2.e3c79aa1.png";